import TopBar from "./TopBar";
import { APP_NAME, APP_HERO_SUBTITLE } from "../constants/navigation";

interface HeaderProps {
  showHero?: boolean;
}

const Header = ({ showHero = false }: HeaderProps) => {
  return (
    <div>
      <TopBar />
      {showHero && (
        <div className="text-center pt-12 pb-4">
          <h1 className="text-[48px] font-medium text-[#1a202c] font-['DM_Sans'] tracking-[-1px] leading-[52px] text-center mx-auto antialiased">
            {APP_NAME}
          </h1>
          <p className="text-gray-600 text-lg font-['DM_Sans'] mt-4">{APP_HERO_SUBTITLE}</p>
        </div>
      )}
    </div>
  );
};

export default Header;
